(function () {

    function formatDate(date) {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric'
      });
    }
  
    function addDays(date, days) {
      const d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }
  
    function setDeliveryDates(container) {
      const today = new Date();
  
      const start = addDays(today, 3);
      const end = addDays(today, 5);
  
      const output = `${formatDate(start)} - ${formatDate(end)}`;
  
      const el = container.querySelector('.delivery-date-range');
      if (el) el.textContent = output;
    }
  
    function init() {
      document
        .querySelectorAll('.estimate-delivery-date-wrapper')
        .forEach(setDeliveryDates);
    }
  
    // Run immediately
    init();
  
    // Handle AJAX / quick view
    new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            node
              .querySelectorAll?.('.estimate-delivery-date-wrapper')
              .forEach(setDeliveryDates);
          }
        });
      });
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  
  })();